import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const ExpandedIcon = ({ isExpanded }) => {
  return isExpanded ? <KeyboardArrowDownIcon fontSize="1rem" /> : <KeyboardArrowRightIcon fontSize="1rem" />;
};

export default ExpandedIcon;
